module.exports = __webpack_public_path__ + "static/media/drug_adverse_events.7268c3d8.png";